import React, {Component} from 'react';
import {Button, Modal as Mod, ModalHeader, ModalBody, ModalFooter} from 'reactstrap';
import Fade from "reactstrap/es/Fade";
import {connect} from "react-redux";
import {bindActionCreators} from "redux";
import * as modalActions from "./actions";
import {Saga} from "../../documentSearch/actions";

class Modal extends Component {

  constructor(props) {
    super(props);
    this.state = {
      modal: true
    };

    this.closeModal = this.closeModal.bind(this);
    this.onClose = this.onClose.bind(this);
  }

  closeModal(confirmed) {
    this.setState(prevState => ({
      modal: false,
      confirmed: confirmed
    }));
  }

  onClose() {
    debugger;
    if (this.state.confirmed) {
      if (this.props.item.onConfirm) {
        this.props.runSaga(this.props.item.onConfirm);
        this.props.onClose(this.props.item);
      }

    } else {

      this.props.onClose(this.props.item);

    }
  }

  render() {
    const {zIndex} = this.props;
    const {type} = this.props.item;

    if (type === 'confirmation') {
      const {id, title, text, confirmLabel = 'Yes', closeLabel = 'No'} = this.props.item;

      const createMarkup = () => ({__html: text});

      return (
        <Mod isOpen={this.state.modal} modalTransition={<Fade />} onClosed={this.onClose}>
          <ModalHeader toggle={() => this.closeModal(false)}>{title}</ModalHeader>
          <ModalBody>
            <div>
              <p id={'content' + id} dangerouslySetInnerHTML={createMarkup()}/>
            </div>
          </ModalBody>
          <ModalFooter>
            <Button color="primary" onClick={() => {this.closeModal(true)}}>{confirmLabel}</Button>
            <Button color="primary" onClick={() => this.closeModal(false)}>{closeLabel}</Button>
          </ModalFooter>
        </Mod>
      )
    } else {
      throw "Unimplemented dialog type"
    }
  }
}

const ConnectedModal = connect(
  function mapStateToProps(state) {
    return {
      modals: state.modal.modals
    };
  },
  function mapDispatchToProps(dispatch) {
    return {
      runSaga: (runSaga) => {
        dispatch(runSaga)
      }
    }
  }
)(Modal);

export default ConnectedModal;